import { fmeaTemplatesConstants } from './fmeaTemplates.actions';

const initial = { loading: false, data: [], error: null };

export function fmeaTemplatesReducer(state = initial, action) {
  switch (action.type) {
    case fmeaTemplatesConstants.LIST_REQUEST:
      return { ...state, loading: true, error: null };
    case fmeaTemplatesConstants.LIST_SUCCESS:
      return { loading: false, data: action.data || [], error: null };
    case fmeaTemplatesConstants.LIST_FAILURE:
      return { loading: false, data: [], error: action.error };
    case fmeaTemplatesConstants.CREATE_SUCCESS:
      return { ...state, data: [action.data, ...state.data] };
    case fmeaTemplatesConstants.UPDATE_SUCCESS:
      return {
        ...state,
        data: state.data.map(t => (t.id === action.data.id ? action.data : t)),
      };
    case fmeaTemplatesConstants.DELETE_SUCCESS:
      return { ...state, data: state.data.filter(t => t.id !== action.templateId) };
    default:
      return state;
  }
}
